function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.4952 19.6392C52.0248 24.9589 59.8578 25.9598 65.5796 21.9501L90.5003 4.48596C93.1398 2.6362 96.3175 5.94499 94.3627 8.5076C90.884 13.0681 92.6142 19.6834 97.8804 21.9567L110.025 27.1993C110.619 27.4558 111.174 27.7947 111.674 28.206L113.581 25.8902L111.674 28.206C116.885 32.4973 113.452 40.9452 106.724 40.3849L75.0585 37.7477C72.8825 37.5664 70.6918 37.6985 68.5534 38.1398L29.1264 46.2756C13.8611 49.4257 0.566311 35.5082 4.41129 20.4029L4.78216 18.9459C8.8509 2.96156 29.261 -1.77538 39.9541 10.7829L47.4952 19.6392Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgTrack2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 50,
    viewBox: "0 0 118 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack2);
export default __webpack_public_path__ + "static/media/track2.53352dfe.svg";
export { ForwardRef as ReactComponent };